import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** 'straight' はスポットを直線で結ぶ。'actual' は最適化が返した道なりの線を描く */
export type RoutePathMode = 'straight' | 'actual'

type RoutePathModeState = {
  mode: RoutePathMode
  setMode: (mode: RoutePathMode) => void
}

export const useRoutePathModeStore = create<RoutePathModeState>()(
  persist(
    (set) => ({
      mode: 'actual',
      setMode: (mode) => set({ mode }),
    }),
    {
      name: 'route-path-mode',
    },
  ),
)
